module.exports = __webpack_public_path__ + "img/privatelayer_en.486b524.jpg";